import { Component, OnInit } from '@angular/core';
import { DataService } from '../../data.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-patient-log',
  templateUrl: './patient-log.component.html',
  styleUrls: ['../patient-profile/patient-profile.component.scss', './patient-log.component.scss']
})
export class PatientLogComponent implements OnInit {

  id: any = '0';
  logMode: any = 1;
  limit: any = 20;
  offset: any = 0;
  data: any = {};
  paymentStatus: any = "";
  selectedDate: any = "";
  selectedDate2: any = "";
  consultant: any = 0;
  therapists: any = [];
  selectedVisit: any = { report: { id: 0, body: "" } }
  blockBills: any = true;
  selectedForCB: any = [];
  generatingCB: any = false;
  cb: any = { status: 0, bills: [], invoice_base: "" }

  constructor(private router: Router, private route: ActivatedRoute, private dataService: DataService) { }

  ngOnInit() {
    this.id = this.route.snapshot.paramMap.get('id');
    this.logMode = this.dataService.localData.selectedPatientLogMode;
    this.offset = this.dataService.localData.selectedPatientLogOffset;
    this.loadData();
    this.loadTherapists();
  }


  setLogMode(mode) {
    this.logMode = mode;
    this.dataService.localData.selectedPatientLogMode = this.logMode;
    this.offset = 0;
    this.loadData();

  }
  selectVisit(visit) {
    this.selectedVisit = visit;
    console.log(this.selectedVisit);
  }

  loadData() {
    if (this.logMode == 1 || this.logMode == 2) {
      this.dataService.getClientAppointments(this.id, this.logMode, this.limit, this.offset, this.selectedDate, this.selectedDate2, this.consultant).subscribe((data: any) => {
        this.data = data;
        this.blockBills = data.block_bills;
      });
    } else if (this.logMode == 3) {
      this.dataService.getPatientBills(this.id, this.paymentStatus, this.limit, this.offset).subscribe((data: any[]) => {
        this.data = data;
        console.log(this.data);
      });
    } else if (this.logMode == 4) {
      this.dataService.getPatientConsolidatedBills(this.id, this.limit, this.offset).subscribe((data: any[]) => {
        this.cb = data;

      });
    }
  }

  loadTherapists() {
    this.dataService.getTherapists(0, 1).subscribe((data: any = { status: 0 }) => {
      if (data.status == 0) {
        this.therapists = data;
        console.log(data);
      }


    });
  }

  paginate(dir) {
    if (dir == 2) {
      this.offset += this.limit;
    } else {
      this.offset -= this.limit;
    }

    this.dataService.localData.selectedPatientLogOffset = this.offset;

    this.loadData();

  }

  toggleCBSelection(id) {
    const index = this.selectedForCB.indexOf(id);

    if (index === -1) {
      // If id is not in the array, add it
      this.selectedForCB.push(id);
    } else {
      // If id is already in the array, remove it
      this.selectedForCB.splice(index, 1);
    }
  }

  createCB() {
    let data = {
      patient_id: this.id,
      bills: this.selectedForCB
    }

    this.generatingCB = true;

    this.dataService.postCreateCB(data).subscribe((res: any) => {
      this.generatingCB = false;
      if (res.status == 0) {

        window.open(res.url); // Use the returned S3 URL
        this.loadData(); // Reload to show the newly created CB in the list
        this.selectedForCB = []; // Clear selection
      } else {
        alert(res.msg);
      }


    });
  }


  openCB(bill) {
    this.dataService.getViewCB(bill.id).subscribe((res: any) => {
      if (res.status == 0) {
        window.open(res.url);
      } else {
        alert("Could not load bill");
      }
    });
  }

}
